import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
// @ts-ignore
import StarRatings from 'react-star-ratings';

import {
  MdMath, Partecipante, CategoriaMap, CategoriaEventoMap, PartecipantiMap, AllegatoMap,
  BottoneVersioniProblema, LinkProblema, BottoneFlagSmistatore, LoadingCircle, Spoiler,
  LaTeX, SearchProblema, RealTeXLoad,
} from '../components'
import {
  nice_date, displayPartecipante, displayFlagSmistatore,
  sentry_log, displayFonte, displayCompetenza
} from '../utils';
import { ThreadDettaglio } from '../api/types';
import { canEditProblema, canAssegnareProblemi, star_style, canSetSmistatoreFlag } from '../globals';
import {
  post_bellezza, post_difficolta,
  get_bellezza, get_difficolta, build_tex_problema_post, build_tex_soluzione_post, build_tex_problema_get, build_tex_soluzione_get,
} from '../api';
import { useLogin, useThread, useAllegato, useEvento, useCategoriaEvento, useShortlist, useCompetenza } from '../reducers'


interface ownProps {
  thread: ThreadDettaglio,
  pageHeading?: boolean,
}


const Problema = (props: ownProps) => {
  const { thread } = props;
  const { problema } = thread;

  const login = useLogin();
  const thread_list = useThread(props);
  const shortlists = useShortlist(props);
  const competenze = useCompetenza(props);
  useAllegato(props);
  const catEvento = useCategoriaEvento(props);
  const eventi = useEvento(props);
  const [bellezza, setBellezza] = useState(0);
  const [difficolta, setDifficolta] = useState(0);
  const [hideProblema, setHideProblema] = useState(false);
  const [hideSoluzione, setHideSoluzione] = useState(false);

  useEffect(() => {
    const pk = thread.problema.id;
    get_bellezza({ partecipante: login.user.id, problema: pk }).then(ans => ans.length > 0 && setBellezza(ans[0].voto))
    get_difficolta({ partecipante: login.user.id, problema: pk }).then(ans => ans.length > 0 && setDifficolta(ans[0].voto))
  }, [props.thread.problema.id])

  const last_versione = problema.versioni[problema.versioni.length - 1];
  const modificato = (problema.versioni.length > 1)
  const data_pubblicazione = nice_date(new Date(problema.data_pubblicazione));
  const data_modifica = nice_date(new Date(last_versione.data));
  const modificato_da_altri = last_versione.autore != problema.propositore;
  const extra = modificato_da_altri ? ` da ${displayPartecipante(last_versione.autore)}` : "";
  const testo_data = modificato ?
    `Pubblicato: ${data_pubblicazione}. Modificato l'ultima volta${extra}: ${data_modifica}` :
    `${data_pubblicazione}`;
  const bottone_modifica = ((login.user.id == problema.propositore) ||
    canEditProblema(login.user, problema, shortlists.map(s => s.shortlist))) ?
    <Link to={`/thread/problema/edit/${thread.id}/`}
      className="btn btn-warning mr-3 mb-2" title="Modifica il problema">
      <i className="fa fa-edit mr-1" aria-hidden="true" /> Modifica
    </Link> : null;
  const change_rating = (post_function: typeof post_bellezza | typeof post_difficolta, name: "difficolta" | "bellezza") => (newrating: number) => {
    post_function({ problema: problema.id, voto: newrating })
      .then(risposta => {
        const setVal = name === "difficolta" ? setDifficolta : setBellezza;
        setVal(risposta.voto);
      })
      .catch(error => sentry_log(error));
  }
  const bottone_assegna = canAssegnareProblemi(login.user.permessi) ?
    <Link to={`/thread/problema/${thread.id}/assegna/`}
      className="btn btn-belize-hole mr-3 mb-2" title="Assegna il problema">
      <i className="fa fa-hand-point-right mr-1" aria-hidden="true" /> Assegna
    </Link>
    : null;
  const bottone_versioni = modificato ?
    <BottoneVersioniProblema problema={problema} />
    : null;
  const bottone_voti = (
    <Link to={`/thread/problema/${thread.id}/voti/`}
      className="btn btn-success mr-3 mb-2" title="Voti assegnati al problema">
      <i className="fa fa-star mr-1" aria-hidden="true" /> Voti
    </Link>
  );
  const bottone_flag_smistatore = canSetSmistatoreFlag(login.user.permessi) ?
    <BottoneFlagSmistatore
      thread={thread}
      thread_list={thread_list}
    />
    : null;
  const bottone_ricerca = <SearchProblema id={problema.id} />
  const short_comparso = shortlists.filter(short => short.shortlist.versioni[short.shortlist.versioni.length - 1].lista_problemi.includes(thread.problema.id))

  const eventi_testo_lungo = new Set(catEvento.filter(ev => ev.tipologia === "seni" || ev.tipologia === "tstipho").map(ev => ev.id))
  // @ts-ignore
  const proposto_senigallia = eventi_testo_lungo.size > 0 && (new Set(problema.eventi_proposto)).intersection(eventi_testo_lungo).size > 0
  const new_iframe_height = proposto_senigallia ? { iframe_height: "80vh" } : {};

  return (
    <div className="card my-1">
      <div className="card-header">
        <div className="conatiner">
          {props.pageHeading ? (
            <>
              <h1 className="h2 mb-1 text-break">#{thread.id} — {thread.titolo}</h1>
              {thread.titolo !== problema.titolo && (
                <div className="mb-2">
                  <span className="small text-muted">Titolo sul foglio di gara</span>
                  <h2 className="h3 mb-0 text-break">{problema.titolo}</h2>
                </div>
              )}
              <p className="text-muted mb-3">
                Proposto da <Link to={`/utente/${problema.propositore}/`}>{displayPartecipante(problema.propositore)}</Link>
                {' · '}Pubblicato il {data_pubblicazione}
              </p>
            </>
          ) : (
            <h3>#{thread.id} - {thread.titolo}{thread.titolo != problema.titolo && ` [${problema.titolo}]`}</h3>
          )}
          {thread.problema.evento_assegnato &&
            <h5><i className="text-danger mr-1 fa fa-times" /> {`Problema assegnato nell'evento ${eventi.find(ev => ev.id == thread.problema.evento_assegnato)?.titolo}`}</h5>}
          {short_comparso.length > 0 &&
            <h5><i className="text-warning mr-1 fa fa-exclamation-triangle" />Problema presente nelle shortlist: {short_comparso.map(short => <Link key={short.id} to={`/shortlist/${short.id}/`}><span className="mr-2">{short.titolo}</span></Link>)}</h5>}

          <div className="row align-items-start">
            <div className="col-12 col-lg-6">
              <dl className="mb-0">
                <dt className="small text-muted mb-1">Categorie</dt>
                <dd className="mb-2">
                  {problema.categoria.length > 0 ? <CategoriaMap categorie={problema.categoria} />
                    : <span className="small text-muted">Nessuna categoria</span>}
                </dd>
                <dt className="small text-muted mb-1">Proposto per gli eventi</dt>
                <dd className="mb-0 overflow-auto" style={{ maxHeight: "120px" }}>
                  {problema.eventi_proposto.length > 0 ? <CategoriaEventoMap cats={problema.eventi_proposto} />
                    : <span className="small text-muted">Nessun evento</span>}
                </dd>
              </dl>
            </div>
            <div className="col-12 col-lg-6 mt-3 mt-lg-0">
              <section className="border rounded bg-white p-2" aria-label="Revisione del problema">
                <h2 className="h6 mb-2">Revisione</h2>
                <div className="row">
                  <div className="col-12 col-sm-6">
                    <dl className="mb-0">
                      <dt className="small text-muted mb-1">Assegnato a</dt>
                      <dd className="mb-0 overflow-auto" style={{ maxHeight: "120px" }}>
                        {problema.correttori_assegnati.length > 0 ? <PartecipantiMap partecipanti={problema.correttori_assegnati} />
                          : <span className="small text-muted">Nessun correttore assegnato</span>}
                      </dd>
                    </dl>
                  </div>
                  <div className="col-12 col-sm-6 mt-2 mt-sm-0">
                    <dl className="mb-0">
                      <dt className="small text-muted mb-1">Corretto da</dt>
                      <dd className="mb-0 overflow-auto" style={{ maxHeight: "120px" }}>
                        {problema.correttori_eseguito.length > 0 ? <PartecipantiMap partecipanti={problema.correttori_eseguito} />
                          : <span className="small text-muted">Nessuna correzione completata</span>}
                      </dd>
                    </dl>
                  </div>
                </div>
              </section>
            </div>
          </div>
          <div className="row">
            {problema.flags_smistatore &&
              <div className="d-flex justify-content-between card">
                <div className="card-body">
                  <h6>Problema marcato come {displayFlagSmistatore(problema.flags_smistatore.flag)} da {displayPartecipante(problema.flags_smistatore.ultimo_revisore)}.</h6>
                  {problema.flags_smistatore.messaggio_extra &&
                    <p>{problema.flags_smistatore.messaggio_extra}</p>}
                  {(problema.flags_smistatore.flag == 'd') &&
                    <h6>Problemi simili: {problema.flags_smistatore.problemi_simili.map(item => {
                      const simile = thread_list.find(i => i.problema.id == item);
                      if (!simile) {
                        return <LoadingCircle key={item} />
                      }
                      return <LinkProblema key={item} thread_list={[simile,]} pk={simile.id} />;
                    })}</h6>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </div>
      <div className="card-body">
        <div className="container-fluid">
          <div className="row pt-2">
            <div className="col-lg-9 pl-4 d-flex align-items-start flex-column" style={{ overflowX: "auto" }}>
              {!hideProblema &&
                <LaTeX text={last_versione.testo} />
              }
              <RealTeXLoad id={thread.id} api={() => build_tex_problema_get(thread.id)} callback={() => setHideProblema(true)} {...new_iframe_height} />
              {problema.commenti_correttori &&
                <div className="row pt-2 card px-2 py-2 my-1">
                  <h6 className="card-title"><i>Note per gli organizzatori</i></h6>
                  <div className="card-body">
                    <MdMath source={problema.commenti_correttori} />
                  </div>
                </div>
              }
              <dl>
                <dt>Fonte:</dt>
                <dd>[{displayFonte(problema.fonte)}] {problema.fonte_verboso}</dd>
              </dl>
              {problema.soluzione_spiegata &&
                <div className="row pt-2 card px-2 py-2 my-1 w-100">
                  <h6 className="card-title"><i>Soluzione proposta</i></h6>
                  <div className="card-body">
                    <Spoiler big showLabel="Mostra soluzione proposta" hideLabel="Nascondi soluzione proposta">
                      {!hideSoluzione &&
                        <LaTeX text={problema.soluzione_spiegata} />
                      }
                      <RealTeXLoad id={thread.id} api={() => build_tex_soluzione_get(thread.id)} callback={() => setHideSoluzione(true)} {...new_iframe_height} />
                    </Spoiler>
                  </div>
                </div>
              }
              {problema.competenze?.length > 0 &&
                <div className="row pt-2 card px-2 py-2 my-1 w-100">
                  <h6 className="card-title"><i>Competenze necessarie</i></h6>
                  <div className="card-body">
                    <Spoiler big showLabel="Mostra competenze necessarie" hideLabel="Nascondi competenze necessarie">
                      <ul>
                        {problema.competenze.map(comp => {
                          const competenza = competenze.find(c => c.id === comp);
                          if (!competenza) return <LoadingCircle key={comp} />;
                          return (
                            <li key={competenza.id}>{displayCompetenza(competenza)}</li>
                          )
                        })}
                      </ul>
                    </Spoiler>
                  </div>
                </div>

              }
              <div className="row mb-4">
                <div className="d-inline-flex flex-row">
                  <AllegatoMap allegati={problema.allegati} />
                </div>
              </div>
              <div className="mt-auto pt-3 border-top w-100" role="group" aria-label="Strumenti del problema">
                <p className="small text-muted mb-2">Strumenti del problema</p>
                <div className="d-flex flex-wrap">
                  {bottone_modifica}
                  {bottone_assegna}
                  {bottone_versioni}
                  {bottone_voti}
                  {bottone_flag_smistatore}
                  {bottone_ricerca}
                </div>
              </div>
            </div>
            <div className="col-lg-3 no-gutters">
              <Partecipante partecipante={problema.propositore} />
            </div>
          </div>
        </div>
      </div>
      <div className="card-footer py-1">
        <small>{testo_data}</small>
      </div>
      <div className="container">
        <div className="row d-flex justify-content-between py-2">
          <span className="px-2">
            Bellezza:
            <StarRatings
              {...star_style}
              changeRating={change_rating(post_bellezza, "bellezza")}
              rating={bellezza}
            />
          </span>
          <span className="px-2">
            Difficoltà:
            <StarRatings
              {...star_style}
              changeRating={change_rating(post_difficolta, "difficolta")}
              rating={difficolta}
            />
          </span>
        </div>
        <div className="d-flex justify-content-end">
          <span>Ricorda di consultare la <Link to="/guida/difficolta/">guida</Link> alla difficoltà.</span>
        </div>
      </div>
    </div >
  );
}

export default Problema;
